/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseCommandResult } from '../../models/base-command-result';
import { SavePlanCommand } from '../../models/save-plan-command';

export interface ApiPlanSavePlanPatch$Plain$Params {
  
    /**
     * Plan Save command
     */
    body?: SavePlanCommand
}

export function apiPlanSavePlanPatch$Plain(http: HttpClient, rootUrl: string, params?: ApiPlanSavePlanPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiPlanSavePlanPatch$Plain.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseCommandResult>;
    })
  );
}

apiPlanSavePlanPatch$Plain.PATH = '/api/Plan/SavePlan';
